var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m414.3 8.46a1485.25 1485.25 0 0 0 -316.6 0c-43 5-84.25 46.23-89.24 89.24a1485.25 1485.25 0 0 0 0 316.6c5 43 46.23 84.25 89.24 89.24a1485.25 1485.25 0 0 0 316.6 0c43-5 84.25-46.23 89.24-89.24a1485.25 1485.25 0 0 0 0-316.6c-4.99-43.01-46.23-84.25-89.24-89.24z",
    fill: "#dd4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.56 400.82c153.63 0 278.17-124.54 278.17-278.16a277.11 277.11 0 0 0 -26.26-118.08 1484.86 1484.86 0 0 0 -274.77 3.88c-43 5-84.25 46.23-89.24 89.24a1484.72 1484.72 0 0 0 -3.62 278 277 277 0 0 0 115.72 25.12z",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227 109.1a29 29 0 0 1 58 0v108.13a29 29 0 1 1 -58 0zm144.56 274.75a163.43 163.43 0 0 1 -231.12 0c-63.72-63.71-63.72-167.39 0-231.11a29 29 0 0 1 41 41 105.43 105.43 0 1 0 149.1 0 29 29 0 0 1 41-41 163.42 163.42 0 0 1 0 231.12z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerLogoutIcon);
export default __webpack_public_path__ + "static/media/power_logout_icon.5f6ba93372fea0079aef091c1698cab7.svg";
export { ForwardRef as ReactComponent };